const PropTypes = require('prop-types');

module.exports = {
  comment: PropTypes.object.isRequired
};
